// Session de l'appareil, gardée dans localStorage (pas d'expiration).
//
// Les comptes partagés n'ont qu'un drapeau « connecté ». Le compte privé reçoit
// en plus un jeton du serveur : lui seul ouvre les Stats et les Textos, et
// chaque appel à ces routes doit le présenter.
import { useSyncExternalStore } from 'react';

const CLE = 'aquarius_auth';
const EVENEMENT = 'aquarius-session';

interface Session {
  authenticated: boolean;
  timestamp: number;
  jetonPrive?: string;
}

function lire(): Session | null {
  try {
    const brut = localStorage.getItem(CLE);
    return brut ? (JSON.parse(brut) as Session) : null;
  } catch {
    return null;
  }
}

export const estConnecte = () => !!lire()?.authenticated;

export const jetonPrive = (): string | null => lire()?.jetonPrive || null;

export function ouvrirSession(jeton?: string) {
  const session: Session = { authenticated: true, timestamp: Date.now() };
  if (jeton) session.jetonPrive = jeton;
  localStorage.setItem(CLE, JSON.stringify(session));
  window.dispatchEvent(new Event(EVENEMENT));
}

export function fermerSession() {
  localStorage.removeItem(CLE);
  window.dispatchEvent(new Event(EVENEMENT));
}

/** En-tête à joindre aux appels des routes Stats, Textos et Jarvis. */
export function enTeteComptePrive(): Record<string, string> {
  const jeton = jetonPrive();
  return jeton ? { Authorization: `Bearer ${jeton}` } : {};
}

function abonner(rappel: () => void) {
  window.addEventListener(EVENEMENT, rappel);
  window.addEventListener('storage', rappel);
  return () => {
    window.removeEventListener(EVENEMENT, rappel);
    window.removeEventListener('storage', rappel);
  };
}

/** Vrai si cet appareil est connecté avec le compte privé. */
export function useComptePrive(): boolean {
  return useSyncExternalStore(abonner, () => !!jetonPrive());
}
